import { Card } from '@repo/shadcn';
import { useDebounce } from '@uidotdev/usehooks';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import {
    AutoCompleteInput,
    Option,
} from '@components/ui/autocomplete/auto-complete-input';

import { UrlSearchFilterProperty } from '@/constants';
import { useGetBrandsQuery } from '@/features/slice/products/brand/brand-api-slice';
import { useUrlFilter } from '@/hooks';
import { TCreatePrePurchaseForm } from '@/modules/purchase/pre-purchase/create-pre-purchase/create-pre-purchase.schema';

export const BrandSelector = () => {
    const { setSearchFilter } = useUrlFilter();

    const [brandSearchText, setBrandSearchText] = useState('');

    const debouncedBrandSearchText = useDebounce(brandSearchText, 500);

    const { data, isFetching, isLoading } = useGetBrandsQuery({
        search: debouncedBrandSearchText,
    });

    const { setValue } = useFormContext<TCreatePrePurchaseForm>();

    const handleBrandChange = (value: Option) => {
        if (!value) {
            setSearchFilter(UrlSearchFilterProperty.BRAND_ID, '');
            setSearchFilter(UrlSearchFilterProperty.BRAND_NAME, '');

            setValue('brand_id', '');
            setValue('brand_name', '');
            return;
        }

        setSearchFilter(UrlSearchFilterProperty.BRAND_ID, value.value);
        setSearchFilter(UrlSearchFilterProperty.BRAND_NAME, value.label);

        setValue('brand_id', value.value);
        setValue('brand_name', value.label);
    };

    const brands =
        data?.data.map((brand: any) => ({
            label: brand.name,
            value: brand.id,
        })) || [];

    return (
        <Card className={'p-4'}>
            <h2>Select Brand</h2>

            <div>
                <AutoCompleteInput
                    isLoading={isLoading || isFetching}
                    options={brands}
                    emptyMessage={'No brand found'}
                    onValueChange={handleBrandChange}
                    onInputChange={setBrandSearchText}
                />
            </div>
        </Card>
    );
};

BrandSelector.displayName = 'BrandSelector';
